<template>
    <div class="down-box" v-if="lectoParams.LectotypeParams.length > 0 || lectoParams.IsSelected">
  
      <!-- SolidWorks特征模型 -->
      <div v-if="docDetail"></div>
      <div
        class="solid-work-btn"
        :class="isModelDown ? '' : 'disable'"
        @click="modelDownStart"
        v-else
      >下载SolidWorks特征模型</div>
  
      <!-- 普通模型 -->
      <div v-if="docDetail"></div>
      <div
        class="down-btn"
        :class="isStepDown ? '' : 'disable'"
        @click="stepDownStart()"
        v-else
      >下载通用模型</div>
  
      <!-- 图纸 -->
      <btn-doc-down :doc="docDetail" downText="下载通用模型" v-if="docDetail"></btn-doc-down>

      <whole-confirm ref="wholeConfirmRef"></whole-confirm>
    </div>
  </template>
  
  <script>
  import {Loading} from 'element-ui'
  import { UserService as ModuleUserService } from '@digital-supply-chain/module'
  import { ApiService, AuthService, UserService, ProductService } from '@/service';
  import Event, {EventEnum} from '@/EventEmeitter'
  import { UtilService } from '@/libs';

  import { download, formatBzjName } from './lectoParamsDown';

  import BtnDocDown from './components/BtnDocDown.vue';

function openUriWithInputTimeoutHack(uri, failCb, successCb) {
    let target = document.createElement('input')
    target.style.width = '0'
    target.style.height = '0'
        target.style.position = 'fixed'
    target.style.top = '0'
    target.style.left = '0'
    document.body.appendChild(target)

    target.focus();
    var handler = _registerEvent(target, "blur", onBlur);
    console.log('focus')
    function onBlur() {
      console.log('blur')
      successCb && successCb()
      handler.remove()
      clearTimeout(timeout)
      document.body.removeChild(target)
    };

    //will trigger onblur
    location.href = uri

    // Note: timeout could vary as per the browser version, have a higher value
    var timeout = setTimeout(function () {
      console.log('setTimeout')
      failCb && failCb()
      handler.remove()
      document.body.removeChild(target)
    }, 1000);
}
 
function _registerEvent(target, eventType, cb) {
    if (target.addEventListener) {
        target.addEventListener(eventType, cb);
        return {
            remove: function () {
                target.removeEventListener(eventType, cb);
            }
        };
    } else {
        target.attachEvent(eventType, cb);
        return {
            remove: function () {
                target.detachEvent(eventType, cb);
            }
        };
    }
}
  
  export default {
    data() {
      return {
        downOption: {},
        isLoading: false,
      }
    },
    inject: ['productDocs','downLoadCheck'],
    props: {
      lectoParams: { default: {} },
      lectoProId: { default: 0 },
      productDetail: { default: {} },
      checkParams: { default: {} },
    },
    components: { BtnDocDown },
    computed: {
      docDetail() {
        let findOne = null;
        this.productDocs.forEach(docs => {
          if(this.lectoParams.SkuName && docs.FileName.toLowerCase()  == this.lectoParams.SkuName.toLowerCase() ) {
            findOne = docs;
          }
        });
        return findOne;
      },
      // solidworks特征模型是否可下载
      isModelDown() {
        return this.lectoParams.IsSelected && this.lectoParams.ModelFileServerPath;
      },
      // 模型是否可下载
      isStepDown() {
        let hasStepMx = false;
        const { IsSeries, IsSelected, StepFileServerPath, ModelFileServerPath } = this.lectoParams;
        if (IsSeries || (this.productDetail.HasModel == 2)) {
          if(StepFileServerPath && IsSelected) {
            hasStepMx = true;
          }
        } else {
          if(ModelFileServerPath || StepFileServerPath && IsSelected) {
            hasStepMx = true;
          }
        }
        return hasStepMx
      }
    },
    methods: {
      modelDownStart() {
        this.downLoadCheck(() => {
          this.modelFileExtDown();
        })
      },
      stepDownStart() {
        this.downLoadCheck(() => {
          this.stepFileExtDown();
        })
      },

      // 下载SolidWorks特征模型
      modelFileExtDown() {
        const { ModelFileServerPath, StepFileName } = this.lectoParams;
        if (!this.isModelDown) return;
        const url = `${ApiService.JrzzApi}/${ModelFileServerPath}?token=${AuthService.token(false)}`;
        this._down_load_file(url, 'model_file');
      },
      // 下载模型
      async stepFileExtDown(isExist = false) {
        const { ModelFileServerPath, StepFileName, StepFileServerPath } = this.lectoParams;
        if (!this.isStepDown) return;
        const url = `${ApiService.JrzzApi}/${ModelFileServerPath}/1?token=${AuthService.token(false)}&fileName=${encodeURI(StepFileName)}`;
        if (!StepFileServerPath && !isExist) {
          this.BuildStepFile();
        }
        const checkStep = await this.stepFileExist();
        if (!checkStep) {
          this.fullLoading = Loading.service({
            lock: true,
            text: '正在生成通用模型...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.5)'
          });
          setTimeout(() => {
            this.stepFileExtDown(true);
          }, 20000)
          return false;
        }
        this.fullLoading && this.fullLoading.close();
        this._down_load_file(
          url,
          'step_file',
          isExist,
        );
      },

      async stepFileExist() {
        const { StepFileName } = this.lectoParams;
        const { ProdID } = this.productDetail;
        return await ProductService.stepFileExist(ProdID, 1, StepFileName);
      },
      // 通知服务端进行模型构建
      BuildStepFile() {
        if (!this.lectoParams.SkuName) return false;
        const SelConfigs = this.lectoParams.LectotypeParams.map(item => ({ ID: item.ID, Value: item.Value }));
        ProductService.SaveStepJson(this.lectoParams.SkuName, this.lectoProId, SelConfigs);
      },

      // 文件下载
      async _down_load_file( url = '', file_type = '', isExist = false) {
        if (!ModuleUserService.token()) {
          Event.emit(EventEnum.LOGIN_OPEN);
          return false;
        }
        let fileName = '';
        if (this.productDetail.CompID == 0) {
          fileName = formatBzjName(this.productDetail.ProdName, this.productDetail.PromoteName, this.lectoParams.SkuName, this.lectoParams);
        } else {
          fileName = UtilService.SpecialCharacter(`${this.productDetail.ProdName}[${this.lectoParams.SkuName}]`);
        }
        const file_ext = file_type === 'model_file' ? this.lectoParams.ModelFileExt : 'step';
        let savePath = fileName + '.' + file_ext; 
        this.downOption = download(savePath, file_type, this.lectoParams, this.productDetail, this.IsAddToCurrentAssembly, this.lectoProId);

        console.log(this.downOption);
        const key = `bigengineer_pc_lecto_${ModuleUserService.user().UserID}`;
        await UserService.setData(key, JSON.stringify(this.downOption), 3600);
        let protocalUrl = `bigengineerservice://${key}`;
        openUriWithInputTimeoutHack(protocalUrl, () => {
          this.$refs.wholeConfirmRef.open({
            width: '350px',
            content: '<div>友情提示：<br/>下载三维模型需要安装模型下载引擎，请问您想安装吗？</div>',
            confirmText: '安装',
            showCancel: true,
            confirm: () => {
              window.open(`${ApiService.OssHzHost}/bigengineer/BigEngineerSrv.exe?v=${new Date().getTime()}`)
            }
          })
        }, () => {
            // 浏览器弹窗提示
          console.log('检测到：已安装了客户端')
        })

      },
    }
  }
  </script>
  
  <style lang="less" scoped>
  .set-icon{
    position: absolute;
    right: 7px;
    top: 7px;
    width: 26px;
    height: 26px;
    font-size: 20px;
    color: #606266;
    cursor: pointer;
    text-align: center;
    line-height: 25px;
  }
  .down-box{
    width: 100%;
    height: 42px;
    background: #F1F1F1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    position: relative;
    &>div.disable{
      background: #ccc;
      cursor: not-allowed;
    }
  
    /deep/ .doc-download{
      width: 100px;
      height: 30px;
      background: #DA9B3D;
      color: #ffffff;
      border-radius: 4px;
      margin-left: 12px;
    }
  }
  .solid-work-btn{
    width: 200px;
    height: 30px;
    background: linear-gradient(90deg, #0989C5 0%, #995CB6 100%);
    border-radius: 4px;
    margin-right: 12px;
    text-align: center;
    line-height: 30px;
    color: #ffffff;
    cursor: pointer;
  }
  .down-btn{
    width: 100px;
    height: 30px;
    background: #DA9B3D;
    border-radius: 4px;
    text-align: center;
    line-height: 30px;
    color: #ffffff;
    cursor: pointer;
  }
  .solid-work-view{
    width: 200px;
    height: 30px;
    margin-right: 12px;
  }
  .down-view{
    width: 100px;
    height: 30px;
  }
  .solid-work-view,.down-view{
    background: #ccc;
    cursor: not-allowed;
    position: relative;
    text-align: center;
    line-height: 30px;
    color: #ffffff;
    border-radius: 4px;
    overflow: hidden;
    &.open{
      cursor: pointer;
    }
    &>div{
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
    }
    &>span{
      position: relative;
      z-index: 2;
    }
  }
  </style>
  